import React from 'react';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import I18n from 'i18n-js';

// Survey ids for each language version from wufoo
const languageSurveyIdMap = {
  en: 'sunumja1yp1h6t',
  fr: 'spd8qaf092okcw',
  de: 'sumvtyd1wpyksk',
  es: 'srk0n3n0tbrktt',
  it: 'wxdyzwd0kr0wr2',
};

export default function ReferralSurveyEmbed() {
  const { id, locale } = useUser();
  const surveyId = languageSurveyIdMap[locale];

  React.useEffect(() => {
    const script = document.createElement('script');

    script.innerHTML = `var survey; (function(d, t) { var s = d.createElement(t), options = { 'userName':'reverbdotcom', 'formHash':'${surveyId}', 'autoResize':true, 'height':'367', 'async':true, 'host':'wufoo.com', 'header':'show', 'ssl':true, 'defaultValues':'field3=${id}' }; s.src = ('https:' == d.location.protocol ?'https://':'http://') + 'secure.wufoo.com/scripts/embed/form.js'; s.onload = s.onreadystatechange = function() { var rs = this.readyState; if (rs) if (rs != 'complete') if (rs != 'loaded') return; try { survey = new WufooForm(); survey.initialize(options); survey.display(); } catch (e) { } }; var scr = d.getElementsByTagName(t)[0], par = scr.parentNode; par.insertBefore(s, scr); })(document, 'script');`;
    script.async = true;
    document.body.appendChild(script);
  }, [id, surveyId]);

  if (!surveyId) {
    return null;
  }

  return (
    <div className="bd-1 bd-primary bd-radius-primary plr-4">
      <h2 className="cms-h3 weight-bold">{I18n.t('discovery.referralSurvey.header')}</h2>
      <div id={`wufoo-${surveyId}`} />
    </div>
  );
}
